/* eslint-disable array-callback-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-continue */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect,useRef } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { useHistory } from 'react-router-dom';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import Dialog from '@material-ui/core/Dialog';
import { useDispatch, useSelector } from 'react-redux';
import { isNaN } from 'lodash';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as message from './message';
import DatesGrid from './datesGrid';
import TabPanel from './planTabs';
import PlanContactForm from './planContactForm';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  getPlansByCgp,
  resetUpdateContactDetail,
  resetUpdateOrSaveMessage,
  deletePlanHandleFromGridComponent,
  getAllClientsDropDown,
  getAllGroupsDropDown,
  getRebateProgramCodeFromCGP,
  postSaveOrUpdate,
  deletePlanDetails,
  updateDatesRows,
  createNewPlanToStore,
  dispatchContactDetailsPlan,
  setPlanTabData,
  resetContactData,
  getExistingContactDetails,
  getAllContactType,
  getContactDetails,
} from '../store/actions';
import {
  compareTwoDatesGreaterThanOrEqual,
  getUTCTimeStampMMDDYYYY,
  compareTwoEqualDates,
} from '../../../../SharedModules/DateUtilities/DateUtilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  setAddGroup,
  setGroupDetailsAndParticptionDates,
  setGroupTabDataAction,
} from '../../group/store/group-action';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  CLIENT_ID_REQ,
  GROUP_ID_REQ,
  INVALID_DATE_FORMAT,
  ONE_EMPTY_END_DT,
  PLAN_ID_REQ,
  PLAN_NAME_CD_REQ,
  START_DATE_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  closeTab,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  getRebatePgmDetail,
  tabValue,
} from '../../RebateProgram/MaintainRebate/store/actions';
import { getPlanTypeCdUsingRebateProg } from '../../../Invoice/GenerateInvoice/store/Actions';
import { setTabValue } from '../../client/store/actions';
import {
  checkActionAccessByRole,
  PaperComponent,
  isReadOnly as readOnly,
} from '../../../../SharedModules/utilities/utilities';

function CreateNewPlanForm({ location, history }) {
  const dispatch = useDispatch();
  const getAllClientsDropDownValue = () => dispatch(getAllClientsDropDown());
  const resetUpdateOrSaveMessageHandler = (value) =>
    dispatch(resetUpdateOrSaveMessage(value));
  const getAllGroupsDropDownValue = (value) =>
    dispatch(getAllGroupsDropDown(value));
  const getRebateProgramCodeFromCGPValue = () =>
    dispatch(getRebateProgramCodeFromCGP());
  const postDeletePlanDetails = (value) => dispatch(deletePlanDetails(value));
  const saveOrUpdate = (value) => dispatch(postSaveOrUpdate(value));
  const resetUpdateContactDetailHanler = (value) =>
    dispatch(resetUpdateContactDetail(value));
  const getPlansByCGPValue = (values) => {
    dispatch(getPlansByCgp(values));
  };
  const deletePlanHandleFromGridComponentHandler = (value) =>
    dispatch(deletePlanHandleFromGridComponent(value));
  const planSearchOrAdd = window.localStorage.getItem('planSearchOrAdd');
  const allClientDropDown = useSelector((state) => {
    return state.sharedState.PlanReducer.allClientDropDown;
  });
  const plansByCgp = useSelector((state) => {
    return state.sharedState.PlanReducer.plansByCgp;
  });
  const saveOrUpdateMessage = useSelector((state) => {
    return state.sharedState.PlanReducer.saveOrUpdateMessage;
  });
  const deletePlan = useSelector((state) => {
    return state.sharedState.PlanReducer.deletePlan;
  });
  const allGropsDropDown = useSelector((state) => {
    return state.sharedState.PlanReducer.allGropsForClientDropDown;
  });
  const allRebateProgramCode = useSelector((state) => {
    return state.sharedState.PlanReducer.allRebateProgramCode;
  });
  const updateOrSaveContactDetailsMessage = useSelector((state) => {
    return state.sharedState.PlanReducer.updateOrSaveContactDetailsMessage;
  });
  const softDeleteData = useSelector((state) => {
    return state.sharedState.PlanReducer.softDeleteRowData;
  });
  const deleteMessageResponse = useSelector((state) => {
    return state.sharedState.PlanReducer.deleteMessageResponse;
  });
  const allContactData = useSelector((state) => {
    return state.sharedState.PlanReducer.allContactData;
  });
  const contactDetails = useSelector((state) => {
    return state.sharedState.PlanReducer.contactDetails;
  });
  const planTabData = useSelector((state) => {
    return state.sharedState.PlanReducer.planTabData;
  });
  const fetchedPlanTypeCd = useSelector((state) => {
    return state.sharedState.GenerateInvoiceReducer?.planTypeCd;
  });

  const userDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );

  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const datesGridApiRef = useRef(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [planTabValue, setPlanTabValue] = useState(
    planTabData?.tabValue ?? 'one'
  );
  const [openCancel, setOpenCancel] = useState(false);
  const [planByCGP, setPlanByCGP] = useState(plansByCgp);
  const [disabledSaveCancelBtn, setDisabledSaveCancelBtn] = useState(
    planTabData?.disabledSaveCancelBtn ?? true
  );
  const [fullScreenView, setFullScreenView] = useState(false);
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [savePopup, setSavePopup] = useState(false);
  const [isResetClicked, setIsResetClicked] = useState(false);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = React.useState(false);
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly = false;
  if (loginState) {
    isReadOnly =
      readOnly(window.location.pathname, loginState)?.readOnly || false;
  }
  const [hasAccessbyRole, setHasAccessbyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccessbyRole(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  const [error, setError] = useState({
    clientIdError: '',
    groupIdError: '',
    planIdError: '',
  });
  const [successMessages, setSucessMessage] = useState([]);

  const [isUserChangedValue, setIsUserChangedValue] = useState(false);
  const initialValuesData = {
    clientId: '-1',
    clientName: null,
    groupId: '-1',
    groupName: null,
    planId: '',
    planName: null,
    rebateProgramCd: null,
    contactTypeCd: '-1',
  };

  const initialCGPValue = [
    {
      newRecord: true,
      cg_id: null,
      cgpId: {
        clientId: '',
        groupId: '',
        planId: '',
        startDt: null,
      },
      index: 0,
      endDt: null,
      planName: '',
      rebateProgramCd: '',
      ltcPlanInd: 0,
      excludeSuppInd: 0,
      lastUpdateDt: '',
      lastUpdateUserId: '',
      corrLinkId: null,
      clientName: '',
      groupName: '',
      startDt: null,
    },
  ];
  const [values, setValues] = useState({
    ...initialValuesData,
    ...allContactData,
  });
  const [errorMessages, setErrorMessages] = useState(
    planTabData?.errorMessages?.length > 0
      ? [...planTabData?.errorMessages]
      : []
  );
  const [contactErrors, setContactErrors] = useState([]);
  const [contactFormDirty, setContactFormDirty] = useState(false);
  const [
    {
      showStartDateError,
      showEndDareErr,
      showEndDateGreaterError,
      showInvalidStartDateOrEndDateError,
      dateOverlaping,
      showSameStartDateError,
      ContactErr,
    },
    setShowError,
  ] = useState(false);

  const dispatchPlanTabData = (data) => {
    dispatch(setPlanTabData(data));
  };

  /** Tab switch refresh functionality */
  useEffect(() => {
    setValues({
      ...values,
      ...allContactData,
    });
  }, [planTabValue]);

  /** Store plan tab data */
  useEffect(() => {
    dispatchPlanTabData({
      ...planTabData,
      errorMessages,
      disabledSaveCancelBtn,
    });
  }, [disabledSaveCancelBtn, errorMessages]);

  // handling refresh functionality
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (
          item.navTo === '/createNewPlan' &&
          (!disabledSaveCancelBtn || contactFormDirty)
        ) {
          item.isFormDirty = true;
          if (errorMessages && errorMessages.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        } else if (item.navTo === '/createNewPlan') item.isFormDirty = false;
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [disabledSaveCancelBtn, contactFormDirty, errorMessages]);

  const thisHistory = useHistory();

  useEffect(() => {
    if (saveOrUpdateMessage === 'success') {
      setSucessMessage([message.SUCESS_MESSAGE]);
      setDisabledSaveCancelBtn(true);
      setContactFormDirty(false);
      setTabValue(tabValue);
      dispatch(
        getExistingContactDetails(
          {
            key: [
              `${values?.clientId?.trim()}${values?.groupId?.trim()}${values?.planId?.trim()}`,
            ],
            keyTypeCd: 'CGP',
          },
          'plan'
        )
      );
      dispatch(getAllContactType({ keyTypeCd: 'CGP' }, 'plan'));
      dispatch(
        getContactDetails(
          {
            keyTypeCd: 'CGP',
            key: `${values?.clientId?.trim()}${values?.groupId?.trim()}${values?.planId?.trim()}`,
            contactTypeCd: allContactData?.contactTypeCd,
          },
          'plan'
        )
      );
      if (!clickOncloseTabBtn) {
        // closeTab('/createNewPlan', thisHistory, dispatch);
        saveOrUpdate(null);
      }
      dispatchPlanTabData({});
    }
    if (saveOrUpdateMessage === 'failed') {
      setErrorMessages([message.ERROR_MESSAGE]);
      setSucessMessage([]);
    }
    if (
      saveOrUpdateMessage.status === 500 &&
      saveOrUpdateMessage.data &&
      saveOrUpdateMessage.data.message
    ) {
      setErrorMessages([saveOrUpdateMessage?.data?.message]);
    }
    setSpinnerLoader(false);
  }, [saveOrUpdateMessage]);

  useEffect(() => {
    if (plansByCgp && plansByCgp.length) {
      let i;
      for (i = 0; i < plansByCgp.length; i += 1) {
        plansByCgp[i].endDt = plansByCgp[i].endDt;
      }
    }
    setPlanByCGP(plansByCgp);
    if (isResetClicked) {
      dispatch(updateDatesRows(plansByCgp));
    }
  }, [plansByCgp]);

  useEffect(() => {
    setSpinnerLoader(false);
    let rebateProgramCd = '';
    let planName = '';
    let clientName = '';
    if (
      plansByCgp &&
      plansByCgp.length &&
      plansByCgp.length > 0 &&
      plansByCgp[0].cgpId
    ) {
      const { cgpId } = plansByCgp[0];
      plansByCgp.forEach((element) => {
        if (element.endDt === null || element.endDt === '') {
          planName = element.planName;
          rebateProgramCd = element.rebateProgramCd;
        }
      });
      if (!planName) {
        planName = plansByCgp.reduce((a, b) =>
          a.endDt > b.endDt ? a : b
        )?.planName;
        rebateProgramCd = plansByCgp.reduce((a, b) =>
          a.endDt > b.endDt ? a : b
        )?.rebateProgramCd;
      }
      allClientDropDown &&
        allClientDropDown.length &&
        allClientDropDown.length > 0 &&
        allClientDropDown.forEach((item) => {
          if (item.clientId === cgpId.clientId) {
            clientName = item.clientName;
          }
        });
      if (planSearchOrAdd === 'add') {
        setValues(initialValuesData);
      } else {
        setValues({
          ...values,
          clientId: cgpId.clientId,
          groupId: cgpId.groupId,
          planId: cgpId.planId,
          clientName: clientName,
          rebateProgramCd: rebateProgramCd,
          planName: planName,
        });
      }
    }
    getAllClientsDropDownValue();
    getRebateProgramCodeFromCGPValue();
    setSucessMessage([]);
    setErrorMessages([]);
    resetUpdateContactDetailHanler('');
    if (rebateProgramCd)
      dispatch(
        getPlanTypeCdUsingRebateProg({
          rebateProgramCd: rebateProgramCd,
        })
      );
    dispatch(updateDatesRows(plansByCgp));
  }, []);
  React.useEffect(() => {
    if (values?.planId) {
      dispatch(
        getExistingContactDetails(
          {
            key: [
              `${values?.clientId?.trim()}${values?.groupId?.trim()}${values?.planId?.trim()}`,
            ],
            keyTypeCd: 'CGP',
          },
          'plan'
        )
      );
    }
    dispatch(getAllContactType({ keyTypeCd: 'CGP' }, 'plan'));
  }, []);
  useEffect(() => {
    if (values.clientId && values.clientId !== '-1') {
      getAllGroupsDropDownValue({
        clientId: values.clientId,
        groupId: null,
      });
    }
  }, [values.clientId]);

  useEffect(() => {
    if (
      isUserChangedValue === false &&
      plansByCgp &&
      plansByCgp.length &&
      plansByCgp.length > 0 &&
      plansByCgp[0].cgpId
    ) {
      const { cgpId } = plansByCgp[0];
      let clientName = '';
      let groupName = '';
      let rebateProgramCd = rebateProgramCd;
      let planName = '';
      plansByCgp.forEach((element) => {
        if (element.endDt === null || element.endDt === '') {
          planName = element.planName;
          rebateProgramCd = element.rebateProgramCd;
        }
      });
      if (!planName) {
        planName = plansByCgp.reduce((a, b) =>
          a.endDt > b.endDt ? a : b
        )?.planName;
        rebateProgramCd = plansByCgp.reduce((a, b) =>
          a.endDt > b.endDt ? a : b
        )?.rebateProgramCd;
      }

      allClientDropDown &&
        allClientDropDown.length &&
        allClientDropDown.length > 0 &&
        allClientDropDown.forEach((item) => {
          if (item.clientId === cgpId.clientId) {
            clientName = item.clientName;
          }
        });
      allGropsDropDown &&
        allGropsDropDown.length &&
        allGropsDropDown.length > 0 &&
        allGropsDropDown.forEach((item) => {
          if (item.groupId === cgpId.groupId) {
            groupName = item.groupName;
          }
        });
      if (planSearchOrAdd === 'add') {
        setValues(initialValuesData);
      } else {
        setValues({
          ...values,
          clientId: cgpId.clientId,
          groupId: cgpId.groupId,
          planId: cgpId.planId,
          clientName: clientName,
          groupName: groupName,
          rebateProgramCd: rebateProgramCd,
          planName: planName,
        });
      }
    }
  }, [allGropsDropDown]);
  useEffect(() => {
    if (
      isUserChangedValue === true &&
      plansByCgp &&
      plansByCgp.length &&
      plansByCgp.length > 0 &&
      plansByCgp[0].cgpId
    ) {
      let clientName = '';
      let groupName = '';
      allClientDropDown &&
        allClientDropDown.length &&
        allClientDropDown.length > 0 &&
        allClientDropDown.forEach((item) => {
          if (item.clientId === values.clientId) {
            clientName = item.clientName;
          }
        });
      allGropsDropDown &&
        allGropsDropDown.length &&
        allGropsDropDown.length > 0 &&
        allGropsDropDown.forEach((item) => {
          if (item.groupId === values.groupId) {
            groupName = item.groupName;
          }
        });
      setValues({ ...values, clientName: clientName, groupName: groupName });
    }
  }, [values.clientId, values.groupId]);
  useEffect(() => {
    setSpinnerLoader(false);
    if (updateOrSaveContactDetailsMessage === 'Success') {
      setSucessMessage([message.SUCESS_MESSAGE]);
    } else {
      setSucessMessage([]);
    }
  }, [updateOrSaveContactDetailsMessage]);
  useEffect(() => {
    setSpinnerLoader(false);
    if (deleteMessageResponse === 'successfully deleted') {
      setSucessMessage([message.SUCESS_MESSAGE]);
    } else {
      setSucessMessage([]);
    }
  }, [deleteMessageResponse]);

  // close popup on click button
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/createNewPlan' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/createNewPlan' && item.isFormSave) {
          item.isFormSave = false;
          setClickOncloseTabBtn(false);
          if (validateRequest()) {
            setErrorMessages([]);
            saveOrUpdateHandler();
          }
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

const resetAllFields = () => {
  setIsResetClicked(true);
  setIsUserChangedValue(false);          // allow effects to repopulate IDs from Redux
  setDisabledSaveCancelBtn(true);        // disable Save and Cancel after reset
  setContactFormDirty(false);
  setErrorMessages([]);
  setSucessMessage([]);
  setContactErrors([]);
  setError({
    clientIdError: '',
    groupIdError: '',
    planIdError: '',
  });
  dispatchPlanTabData({});
  dispatch(resetContactData());
  if (planSearchOrAdd === 'add') {
    setValues(initialValuesData);
    dispatch(createNewPlanToStore(initialCGPValue));
    dispatch(dispatchContactDetailsPlan([]));
  } else {
    const searchCritiria = JSON.parse(
      window.localStorage.getItem('planSearchCriteria')
    );
    getPlansByCGPValue(searchCritiria);
  }
  handelCancelClose();
};

  const handleOnChangeEvent = (e, name) => {
    setDisabledSaveCancelBtn(false);
    setIsUserChangedValue(true);
    setValues({ ...values, [name]: e.target.value });
    setSucessMessage([]);
  };
  const validDate = (d, value, fealed) => {
    if (value === null && fealed === 'start') {
      return false;
    }
    if (value === null && fealed === 'end') {
      return true;
    }
    let isValidDate = false;
    if (Object.prototype.toString.call(d) === '[object Date]') {
      if (!isNaN(d.getTime())) {
        isValidDate = true;
      } else {
        isValidDate = false;
      }
    } else {
      isValidDate = false;
    }
    return isValidDate;
  };
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const validateRequest = (tblData, check = true) => {
    let formIsValid = true;
    const errorMessagesArray = [];
    let showClientIdError = false;
    let showGroupIdError = false;
    let showPlanIdError = false;
    let showPlanNameErr = false;
    // let showRebateProgramErr = false;
    let showStartDateErr = false;
    let showEndDateError = false;
    let showInvalidStartDateOrEndDateErr = false;
    let showEndDateGreaterErr = false;
    let dateOverlapping = false;
    let showSameStartDateErr = false;
    let ContactError = false;
    let clientIdError;
    let groupIdError;
    let planIdError = '';
    let tablecheck = tblData ? tblData : plansByCgp;
    const getRowNo = (record, idx) => {
      let rowNo = idx + 1;
      datesGridApiRef.current?.forEachNode((node) => {
        if (node.data?.index === record?.index && node.rowIndex !== null) {
          rowNo = node.rowIndex + 1;
        }
      });
      return rowNo;
    };
    for (let i = 0; i < tablecheck.length; i += 1) {
      if (tablecheck[i].deleteRecord || tablecheck[i].index === undefined) {
        continue;
      } else {
        if (!tablecheck[i].planName && showPlanNameErr === false) {
          showPlanNameErr = true;
          errorMessagesArray.push(PLAN_NAME_CD_REQ);
        }
        /*  if (
          plansByCgp[i].rebateProgramCd === '-1' ||
          (!plansByCgp[i].rebateProgramCd && showRebateProgramErr === false)
        ) {
          showRebateProgramErr = true;
          errorMessagesArray.push(REBATE_PROG_CD_REQ);
        } */
        if (
          (!tablecheck[i].startDt ||
            tablecheck[i].startDt === 'Invalid date') &&
          showStartDateErr === false
        ) {
          showStartDateErr = true;
          errorMessagesArray.push(START_DATE_REQUIRED);
        } else if (
          tablecheck[i].startDt &&
          tablecheck[i].startDt !== 'Invalid date' &&
          showInvalidStartDateOrEndDateErr === false &&
          validDate(new Date(tablecheck[i].startDt)) === false
        ) {
          showInvalidStartDateOrEndDateErr = true;
          errorMessagesArray.push(INVALID_DATE_FORMAT);
        }
        if (
          tablecheck[i].startDt !== '' &&
          tablecheck[i].startDt !== 'Invalid date' &&
          tablecheck[i].endDt !== null &&
          tablecheck[i].endDt !== '' &&
          tablecheck[i].endDt !== 'Invalid date' &&
          validDate(new Date(tablecheck[i].endDt)) &&
          validDate(new Date(tablecheck[i].startDt)) &&
          compareTwoDatesGreaterThanOrEqual(
            tablecheck[i].endDt,
            tablecheck[i].startDt
          )
        ) {
          showEndDateGreaterErr = true;
          errorMessagesArray.push(
            `End Date is before Start Date on row #${i + 1}`
          );
        }
        if (
          tablecheck[i].endDt &&
          showInvalidStartDateOrEndDateErr === false &&
          validDate(new Date(tablecheck[i].endDt)) === false
        ) {
          showInvalidStartDateOrEndDateErr = true;
          errorMessagesArray.push(INVALID_DATE_FORMAT);
        }

        const notDeletedRec = tablecheck.filter((item) => !item.deleteRecord);
        const endDtEmptyError = notDeletedRec.filter(
          (item) => !item.endDt || item.endDt === 'Invalid date'
        );
        if (endDtEmptyError.length > 1) {
          showEndDateError = true;
          errorMessagesArray.push(ONE_EMPTY_END_DT);
        }

        for (let j = i + 1; notDeletedRec.length > j; j++) {
          if (
            notDeletedRec[i].startDt &&
            notDeletedRec[i].endDt &&
            notDeletedRec[j].startDt &&
            notDeletedRec[j].endDt &&
            validDate(new Date(notDeletedRec[i].startDt)) &&
            validDate(new Date(notDeletedRec[i].endDt)) &&
            validDate(new Date(notDeletedRec[j].startDt)) &&
            validDate(new Date(notDeletedRec[j].endDt))
          ) {
            if (
              new Date(notDeletedRec[i].startDt) <=
                new Date(notDeletedRec[j].endDt) &&
              new Date(notDeletedRec[j].startDt) <=
                new Date(notDeletedRec[i].endDt)
            ) {
              dateOverlapping = true;
              errorMessagesArray.push(
                `Start and End Date overlap in row #${getRowNo(notDeletedRec[i], i)} and ${getRowNo(notDeletedRec[j], j)}`
              );
            }
          } else if (
            notDeletedRec[i].startDt &&
            notDeletedRec[i].endDt &&
            notDeletedRec[j].startDt &&
            !notDeletedRec[j].endDt &&
            validDate(new Date(notDeletedRec[i].startDt)) &&
            validDate(new Date(notDeletedRec[i].endDt)) &&
            validDate(new Date(notDeletedRec[j].startDt))
          ) {
            if (
              new Date(notDeletedRec[j].startDt) >
                new Date(notDeletedRec[i].startDt) &&
              new Date(notDeletedRec[j].startDt) <
                new Date(notDeletedRec[i].endDt)
            ) {
              dateOverlapping = true;
              errorMessagesArray.push(
                `Start and End Date overlap in row #${getRowNo(notDeletedRec[i], i)} and ${getRowNo(notDeletedRec[j], j)}`
              );
            }
          } else if (
            notDeletedRec[i].startDt &&
            !notDeletedRec[i].endDt &&
            notDeletedRec[j].startDt &&
            notDeletedRec[j].endDt &&
            validDate(new Date(notDeletedRec[i].startDt)) &&
            validDate(new Date(notDeletedRec[j].startDt)) &&
            validDate(new Date(notDeletedRec[j].endDt))
          ) {
            if (
              new Date(notDeletedRec[i].startDt) >
                new Date(notDeletedRec[j].startDt) &&
              new Date(notDeletedRec[i].startDt) <
                new Date(notDeletedRec[j].endDt)
            ) {
              dateOverlapping = true;
              errorMessagesArray.push(
                `Start and End Date overlap in row #${getRowNo(notDeletedRec[i], i)} and ${getRowNo(notDeletedRec[j], j)}`
              );
            }
          }
        }
      }
      const notDeletedRec = tablecheck.filter((item) => !item.deleteRecord);
      for (let j = i + 1; notDeletedRec.length > j; j += 1) {
        if (
          validDate(new Date(notDeletedRec[i].startDt)) &&
          validDate(new Date(notDeletedRec[j].startDt)) &&
          compareTwoEqualDates(
            notDeletedRec[i].startDt,
            notDeletedRec[j].startDt
          )
        ) {
          showSameStartDateErr = true;
          errorMessagesArray.push(
            `Start dates are the same on rows #${i + 1} and ${j + 1}`
          );
        }
      }
    }
    if (check && (values.clientId === null || values.clientId === '-1')) {
      showClientIdError = true;
      clientIdError = CLIENT_ID_REQ;
      errorMessagesArray.push(clientIdError);
    }
    if (check && (values.groupId === null || values.groupId === '-1')) {
      showGroupIdError = true;
      groupIdError = GROUP_ID_REQ;
      errorMessagesArray.push(groupIdError);
    }

    if (contactFormDirty && contactErrors && contactErrors.length > 0) {
      ContactError = true;
    }
    if (check && (values.planId === null || values.planId === '')) {
      showPlanIdError = true;
      planIdError = PLAN_ID_REQ;
      errorMessagesArray.push(planIdError);
    }
    if (
      dateOverlapping ||
      showInvalidStartDateOrEndDateErr ||
      showEndDateGreaterErr ||
      showClientIdError ||
      showGroupIdError ||
      showPlanIdError ||
      showPlanNameErr ||
      // showRebateProgramErr ||
      showStartDateErr ||
      showEndDateError ||
      showSameStartDateErr ||
      ContactError
    ) {
      const allErrors = ContactError
        ? contactErrors.concat(errorMessagesArray)
        : errorMessagesArray;
      setError({ ...error, planIdError, groupIdError, clientIdError });
      setErrorMessages([...new Set(allErrors)]);
      setSucessMessage([]);
      formIsValid = false;
    }
    setShowError({
      showClientIdError,
      showGroupIdError,
      showPlanIdError,
      showPlanNameError: showPlanNameErr,
      // showRebateProgramError: showRebateProgramErr,
      showStartDateError: showStartDateErr,
      showEndDareErr: showEndDateError,
      showEndDateGreaterError: showEndDateGreaterErr,
      showInvalidStartDateOrEndDateError: showInvalidStartDateOrEndDateErr,
      dateOverlaping: dateOverlapping,
      showSameStartDateError: showSameStartDateErr,
      ContactErr: ContactError,
      clientIdError,
    });
    return formIsValid;
  };

  const formatCGPPayload = (payload) => {
    const cgpVOListFormatted = [];
    if (payload && payload.length > 0) {
      payload
      // .filter((o) => o.deleteRecord || o.updateRecord || o.newRecord)
        .map((dataItem) => {
          const temObj = {
            cgpId: {
              clientId: dataItem.cgpId.clientId,
              groupId: dataItem.cgpId.groupId,
              planId: dataItem.cgpId.planId,
              startDt: dataItem.cgpId.startDt,
            },
            endDt: dataItem.endDt,
            planName: dataItem.planName,
            rebateProgramCd:
              dataItem.rebateProgramCd === '-1'
                ? null
                : dataItem.rebateProgramCd,
            ltcPlanInd: dataItem.ltcPlanInd,
            excludeSuppInd: dataItem.excludeSuppInd,
            lastUpdateUserId: logInUser || '',
            corrLinkId: dataItem.corrLinkId,
            clientName: dataItem.clientName,
            groupName: dataItem.groupName,
            deleteRecord: dataItem.deleteRecord || false,
            newRecord: dataItem.newRecord || false,
            updateRecord: dataItem.newRecord
              ? false
              : dataItem.updateRecord || true,
            oldStartDt: dataItem.oldStartDt,
          };
          cgpVOListFormatted.push(temObj);
        });
      let formattedPayload = {};
      let contactData = {};
      if (contactFormDirty) {
        let newPhn =
          allContactData &&
          allContactData.phoneNum &&
          allContactData.phoneNum.replace(/-| |/g, '');
        if (newPhn) {
          newPhn = newPhn.replace('(', '');
          newPhn = newPhn.replace(')', '');
          contactData = { ...allContactData, phoneNum: newPhn };
        } else {
          contactData = { ...allContactData };
        }
      }
      formattedPayload = {
        cgpVOList: cgpVOListFormatted,
        contactVO: contactData,
      };
      return formattedPayload;
    }
    setSpinnerLoader(false);
    return setErrorMessages([message.ERROR_MESSAGE]);
  };

  const saveOrUpdateHandler = () => {
    const saveRequest = [...plansByCgp];
    const rowsToDelete = [];
    setSpinnerLoader(true);
    try {
      for (let i = 0; i < saveRequest.length; i += 1) {
        if (
          saveRequest[i].index === undefined &&
          !saveRequest[i]?.cgpId?.startDt
        ) {
          rowsToDelete.push(i);
        } else {
          continue;
        }
      }
      if (rowsToDelete.length > 0) {
        for (let i = rowsToDelete.length - 1; i >= 0; i -= 1)
          saveRequest.splice(rowsToDelete[i], 1);
      }
      if (validateRequest()) {
        setErrorMessages([]);
        setSucessMessage([]);
        setError({
          clientIdError: '',
          groupIdError: '',
          planIdError: '',
        });

        saveRequest.forEach((item) => {
          const formattedStrDt =
            item.startDt !== 'Invalid Date'
              ? getUTCTimeStampMMDDYYYY(item.startDt)
              : null;
          let formattedEndDt;
          if (item.endDt) {
            formattedEndDt =
              item.endDt && item.endDt !== 'Invalid Date'
                ? getUTCTimeStampMMDDYYYY(item.endDt)
                : null;
          } else {
            formattedEndDt =
              item.endDt && item.endDt !== 'Invalid Date'
                ? getUTCTimeStampMMDDYYYY(item.endDt)
                : null;
          }

          item.cgpId.startDt = formattedStrDt;
          item.cgpId.endDt = formattedEndDt;
          item.cgpId.clientId = values.clientId;
          item.cgpId.groupId = values.groupId;
          item.cgpId.planId = values.planId;
          item.ltcPlanInd = item.ltcPlanInd ? 1 : 0;
          item.excludeSuppInd = item.excludeSuppInd ? 1 : 0;
          if (!item.corrLinkId) {
            item.corrLinkId = null;
          }
          item.startDt = formattedStrDt;
          item.endDt = formattedEndDt;
        });
        const payloadFinal = formatCGPPayload(saveRequest);
        saveOrUpdate(payloadFinal);
        resetUpdateOrSaveMessageHandler('');
      } else {
        setSpinnerLoader(false);
      }
    } catch {
      setErrorMessages([message.ERROR_MESSAGE]);
    }
  };

  const handleChangeTabValue = (event, newValue) => {
    setPlanTabValue(newValue);
    dispatchPlanTabData({
      ...planTabData,
      tabValue: newValue,
    });
  };
  const deletePlanHandler = () => {
    if (softDeleteData) {
      softDeleteData.api.applyTransaction({
        remove: [softDeleteData?.node?.data],
      });
    }
    setDisabledSaveCancelBtn(false);
    const updatedArray = planByCGP;
    updatedArray[softDeleteData?.rowIndex].deleteRecord = true;
    setPlanByCGP(updatedArray);
    let afterDeleteRow = [];
    afterDeleteRow = updatedArray.filter((item) => item.deleteRecord !== true);
    dispatch(updateDatesRows(afterDeleteRow));
    deletePlanHandleFromGridComponentHandler({
      index: '',
      shouldDeletePlan: false,
    });
    if (planByCGP?.length === 1) {
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) == null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      const filtered = updateTabs.filter((item) => {
        return item.navTo !== '/createNewPlan';
      });
      localStorage.setItem('tabItemsData', JSON.stringify(filtered));
      history.push({
        pathname: '/plan',
      });
    }
  };

  const handleClickOpenDelete = () => {
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const deleteAllPlans = () => {
    setSpinnerLoader(true);

    postDeletePlanDetails(plansByCgp?.map((item) => item.cgpId));
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    const filtered = updateTabs.filter((item) => {
      return item.value !== 'Maintain Plan';
    });
    localStorage.setItem('tabItemsData', JSON.stringify(filtered));
    handleCloseDelete();
    if (filtered.length > 0) {
      history.push({
        pathname: filtered[filtered.length - 1]?.navTo,
      });
    } else {
      history.push({
        pathname: '/dashboard',
      });
    }
  };

  const goToClient = () => {
    const { clientId } = values;
    window.localStorage.setItem('clientId', clientId);
    window.localStorage.setItem('clientSearchOrAdd', 'search');
    dispatch(setTabValue(0));
    redirectURLLink('/maintain', 'Maintain Client', history, dispatch);
  };

  const goToGroup = () => {
    const { groupId, clientId } = values;
    dispatch(setAddGroup(false));
    dispatch(setGroupDetailsAndParticptionDates(groupId, clientId, true));
    dispatch(
      setGroupTabDataAction({ tabValue: 'one', disableSaveAndCancel: false })
    );
    redirectURLLink('/group-maintain', 'Maintain Group', history, dispatch);
  };

  const goToRebateManage = () => {
    const request = {
      planType: fetchedPlanTypeCd || userDefaultValues?.planTypeCd,
      rebateProg: values?.rebateProgramCd,
    };
    dispatch(getRebatePgmDetail(request));
    dispatch(tabValue('one'));
    redirectURLLink(
      '/maintainRebate',
      'Maintain Rebate Program',
      history,
      dispatch
    );
  };

  const [deletePopup, setDeletePopup] = useState(false);

  useEffect(() => {
    if (deletePlan.shouldDeletePlan) {
      setDeletePopup(true);
    }
  }, [deletePlan.shouldDeletePlan]);

  const handelCancelClose = () => {
    setOpenCancel(false);
  };

  return (
    <>
      <SaveCancelPopup
        open={savePopup}
        title="Save"
        onClose={() => setSavePopup(false)}
        onConfim={async () => {
          setClickOncloseTabBtn(true);
          await saveOrUpdateHandler();
          setSavePopup(false);
        }}
        onCancel={() => {
          setSavePopup(false);
        }}
      />
      <div>
        <div>
          <SaveCancelPopup
            data-testid="handleDelete"
            open={deletePopup}
            title="Delete"
            moduleName="the selected record"
            onConfim={() => {
              setDeletePopup(false);
              deletePlanHandler();
            }}
            onCancel={() => {
              setDeletePopup(false);
              deletePlanHandleFromGridComponentHandler({
                index: '',
                shouldDeletePlan: false,
              });
            }}
            onClose={(reason) => {
              if (reason === 'backdropClick' && reason === 'escapeKeyDown') {
                deletePlanHandleFromGridComponentHandler({
                  index: '',
                  shouldDeletePlan: true,
                });
              }
            }}
          />
          <SaveCancelPopup
            data-testid="handleDeleteAll"
            open={openDelete}
            title="Delete Plan"
            content="This will delete the Plan and all the participation periods as well as close the window"
            onConfim={() => {
              deleteAllPlans();
            }}
            onCancel={() => {
              handleCloseDelete();
            }}
            onClose={(reason) => {
              if (reason === 'backdropClick' && reason === 'escapeKeyDown') {
                handleCloseDelete();
              }
            }}
          />
          <SaveCancelPopup
            open={openCancel}
            title="Cancel"
            onConfim={() => {
              resetAllFields();
            }}
            onCancel={() => {
              handelCancelClose();
            }}
          />

          <Dialog
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
          >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
              Alert
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                unsaved changes will be discarded.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" autoFocus>
                Yes
              </Button>
              <Button color="primary">No</Button>
            </DialogActions>
          </Dialog>
        </div>
        <div className="tBillPanel custom-check">
          <div className="panel tBillPanel-space pb-0">
            <Spinner load={spinnerLoader} />
            <CustomSeparator parent1="Maintain" parent2="Maintain Plan" />
            {!fullScreenView && (
              <>
                <DisplaySuccessMessages successMessages={successMessages} />
                <DisplayErrorMessages errorMessages={errorMessages} />
              </>
            )}
            {!fullScreenView && (
              <fieldset className="custom-fieldset">
                <form autoComplete="off">
                  <div className="form-wrapper form-wrapper-col-4">
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="Client_ID"
                        label="Client ID"
                        className="mandate-fields"
                        fullWidth
                        required
                        select
                        disabled={planSearchOrAdd === 'search' || !isEnablebyRole}
                        placeholder=""
                        inputProps={{
                          maxlength: 11,
                          'aria-labelledby': 'Client_ID',
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        aria-label="Client_ID"
                        value={values.clientId}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'clientId');
                        }}
                        helperText={error.clientIdError}
                        error={error.clientIdError}
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />
                        {allClientDropDown &&
                        allClientDropDown.length &&
                        allClientDropDown.length > 0
                          ? allClientDropDown.map((item) => {
                              return (
                                <MenuItem
                                  key={item.clientId}
                                  value={item.clientId}
                                >
                                  {item.clientId}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </div>
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="Group_ID"
                        label="Group ID"
                        className="mandate-fields"
                        fullWidth
                        required
                        select
                        disabled={planSearchOrAdd === 'search' || !isEnablebyRole}
                        placeholder=""
                        inputProps={{
                          maxlength: 15,
                          'aria-labelledby': 'Group_ID',
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        aria-label="Group_ID"
                        value={values.groupId}
                        onChange={(e) => handleOnChangeEvent(e, 'groupId')}
                        helperText={error.groupIdError}
                        error={error.groupIdError}
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />
                        {allGropsDropDown &&
                        allGropsDropDown.length &&
                        allGropsDropDown.length > 0
                          ? allGropsDropDown.map((item) => {
                              return (
                                <MenuItem
                                  key={item.groupId}
                                  value={item.groupId}
                                >
                                  {item.groupId}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </div>
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="Plan ID"
                        label="Plan ID"
                        className="mandate-fields"
                        fullWidth
                        required
                        placeholder=""
                        disabled={planSearchOrAdd === 'search' || !isEnablebyRole}
                        inputProps={{ maxlength: 10 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={values.planId}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'planId');
                        }}
                        helperText={error.planIdError}
                        error={error.planIdError}
                      />
                    </div>
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="Client_Name"
                        label="Client Name"
                        className="mandate-fields"
                        fullWidth
                        required
                        disabled
                        value={values.clientName}
                        placeholder=""
                        inputProps={{
                          maxlength: 60,
                          'aria-labelledby': 'Client_Name',
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        aria-label="Client_Name"
                      />
                    </div>
                  </div>
                  <div className="form-wrapper form-wrapper-col-4">
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="Group Name"
                        label="Group Name"
                        className="mandate-fields"
                        fullWidth
                        required
                        placeholder=""
                        inputProps={{ maxlength: 60 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={values.groupName}
                      />
                    </div>
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="Plan Name"
                        label="Plan Name"
                        className="mandate-fields"
                        fullWidth
                        required
                        placeholder=""
                        inputProps={{ maxlength: 60 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={values.planName}
                      />
                    </div>
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="Rebate_Program"
                        label="Rebate Program Code"
                        fullWidth
                        disabled
                        select
                        placeholder=""
                        value={values.rebateProgramCd || '-1'}
                        inputProps={{
                          maxlength: 10,
                          'aria-labelledby': 'Rebate_Program',
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        aria-label="Rebate_Program"
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />
                        {allRebateProgramCode &&
                        allRebateProgramCode.length &&
                        allRebateProgramCode.length > 0
                          ? allRebateProgramCode.map((item) => {
                              return (
                                <MenuItem
                                  key={item.rebateProgramCd}
                                  value={item.rebateProgramCd}
                                >
                                  {item.rebateProgramCd}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </div>
                  </div>
                </form>
              </fieldset>
            )}
            {!fullScreenView && (
              <div className="btn-wrapper mb-2">
                <div className="float-right mt-2 hide-on-print">
                  <Button
                    className="btn btn-success btn-search"
                    data-testid="saveBtn"
                    disabled={
                      (disabledSaveCancelBtn && !contactFormDirty) ||
                      !isEnablebyRole
                    }
                    onClick={() => setSavePopup(true)}
                  >
                    <SVGComponent iconName="Icon-awesome-save" />
                    Save
                  </Button>
                  <Button
                    onClick={() => setOpenCancel(true)}
                    disabled={disabledSaveCancelBtn && !contactFormDirty}
                    data-testid="cancelBtn"
                    className="btn btn-cancel btn btn-primary"
                  >
                    <SVGComponent iconName="Icon-cancel" />
                    Cancel
                  </Button>
                </div>
                <div className="clearfix" />
              </div>
            )}

            <div className="tabs-wrapper">
              <div className="float-left">
                <TabPanel
                  handleChangeTabValue={handleChangeTabValue}
                  tabValue={planTabValue}
                  errorMessagesArray={errorMessages}
                  datesTabError={
                    !!(
                      showStartDateError ||
                      showEndDareErr ||
                      showEndDateGreaterError ||
                      showInvalidStartDateOrEndDateError ||
                      dateOverlaping ||
                      showSameStartDateError
                    )
                  }
                  planContatTabError={!!ContactErr}
                />
              </div>
              <div className="clearfix" />
            </div>
            <div className="tabs-body">
              {planTabValue === 'one' ? (
                <div
                  style={{ height: '400px', width: '100%' }}
                  className="ag-theme-alpine"
                >
                  <DatesGrid
                    fullScreenView={fullScreenView}
                    setFullScreenView={setFullScreenView}
                    setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
                    disabledSaveCancelBtn={disabledSaveCancelBtn}
                    handleClickOpenDelete={handleClickOpenDelete}
                    gridHeight={fullScreenView ? '100vh' : 350}
                    goToClient={goToClient}
                    goToGroup={goToGroup}
                    setErrorMessages={setErrorMessages}
                    datesGridApiRef={datesGridApiRef}
                    validateRequest={validateRequest}
                    goToRebateManage={goToRebateManage}
                    cgpValues={values}
                    planByCGP={planByCGP}
                    kcRoles={kcRoles}
                    isReadOnly={isReadOnly}
                    isEnablebyRole={isEnablebyRole}
                    checkActionAccessByRole={checkActionAccessByRole}
                  />
                </div>
              ) : null}
              <div
                style={{
                  display: planTabValue === 'two' ? 'block' : 'none',
                }}
              >
                <PlanContactForm
                  setSuccessMessage={setSucessMessage}
                  keyId={`${values?.clientId?.trim()}${values?.groupId?.trim()}${values?.planId?.trim()}`}
                  defaultValues={values}
                  entityType="CGP"
                  contactType="Plan"
                  keyTypeCd="CGP"
                  setContactErrors={setContactErrors}
                  setIsFormChanged={setDisabledSaveCancelBtn}
                  onContactDirtyChange={setContactFormDirty}
                  contactFormDirty={contactFormDirty}
                  savePopup={savePopup}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default CreateNewPlanForm;
